module.exports = __webpack_public_path__ + "img/组5392@2x.bc85c31e.png";